export const DEFAULT_PAYMENT_METHOD_FOR_PROXY = {
  /** 貨到付款 */
  CASH_ON_DELIVERY: 'cash_on_delivery',
  /** 指定付款 */
  ASSIGNED_PAYMENT_INVOICE: 'assigned_payment_invoice',
  /** 指定付款（不開發票） */
  ASSIGNED_PAYMENT: 'assigned_payment',
} as const

export type DefaultPaymentMethodForProxyType = (typeof DEFAULT_PAYMENT_METHOD_FOR_PROXY)[keyof typeof DEFAULT_PAYMENT_METHOD_FOR_PROXY]

export const ORDER_COMMENT = {
  /** 需附訂單 Invoice */
  NEED_ORDER_PDF: 'need_order_pdf',
  /** 優先出貨 */
  PRIORITY_SHIPPING: 'priority_shipping',
  /** 需附採購單 */
  NEED_PURCHASE_ORDER: 'need_purchase_order',
  /** 特殊加工 */
  SPECIFIC_PROCESS: 'specific_process',
} as const

export type OrderCommentType = (typeof ORDER_COMMENT)[keyof typeof ORDER_COMMENT]

export const SHOP_TYPE = {
  PHYSICAL: 'physical',
  WAREHOUSE: 'warehouse',
  CATTERY: 'cattery',
  KENNEL: 'kennel',
  GROOMING: 'grooming',
  ONLINE: 'online',
  GROUP_BUY: 'group_buy',
  LIVESTREAM: 'livestream',
  PET_HOTEL: 'pet_hotel',
  HUMAN_CHANNEL: 'human_channel',
  ECOMMERCE_PLATFORM: 'ecommerce_platform',
  STUDIO: 'studio',
  VETERINARY: 'veterinary',
  OTHER: 'other',
}

export type ShopType = (typeof SHOP_TYPE)[keyof typeof SHOP_TYPE]

export const shopTypeMap: Record<typeof SHOP_TYPE[keyof typeof SHOP_TYPE], string> = {
  [SHOP_TYPE.PHYSICAL]: '門市',
  [SHOP_TYPE.WAREHOUSE]: '倉庫',
  [SHOP_TYPE.CATTERY]: '貓舍',
  [SHOP_TYPE.KENNEL]: '狗舍',
  [SHOP_TYPE.GROOMING]: '美容',
  [SHOP_TYPE.ONLINE]: '網路',
  [SHOP_TYPE.GROUP_BUY]: '團購',
  [SHOP_TYPE.LIVESTREAM]: '直播',
  [SHOP_TYPE.PET_HOTEL]: '寵物旅館',
  [SHOP_TYPE.HUMAN_CHANNEL]: '人通',
  [SHOP_TYPE.ECOMMERCE_PLATFORM]: '電商平台',
  [SHOP_TYPE.STUDIO]: '工作室',
  [SHOP_TYPE.VETERINARY]: '獸醫院',
  [SHOP_TYPE.OTHER]: '其它',
}

export const INVOICE_TYPE = {
  BUSINESS: 'business',
  PERSONAL: 'personal',
  MOBILE_CARRIER: 'mobile_carrier',
  OTHER: 'other',
}

export type InvoiceType = (typeof INVOICE_TYPE)[keyof typeof INVOICE_TYPE]

export const invoiceTypeMap: Record<typeof INVOICE_TYPE[keyof typeof INVOICE_TYPE], string> = {
  [INVOICE_TYPE.BUSINESS]: '營業用電子發票',
  [INVOICE_TYPE.PERSONAL]: '非營業用電子發票',
  [INVOICE_TYPE.MOBILE_CARRIER]: '手機條碼',
  [INVOICE_TYPE.OTHER]: '其他',
}
